import type React from 'react';
import { QuillInactiveContext } from './quill-inactive-context';

export default function QuillInactiveProvider({ children }: React.PropsWithChildren) {
  return <QuillInactiveContext value={{ hidden: true }}>{children}</QuillInactiveContext>;
}
